export const mockData = {
  events: [
    {
      id: "1",
      src : "system",
      title: "Annual Tech Fest",
      description:
        "Join us for the biggest tech festival of the year with workshops, competitions, and networking.",
      date: "2024-02-15",
      time: "10:00 AM",
      location: "Main Auditorium",
      organizer: "Tech Club",
      category: "Technology",
      maxParticipants: 500,
      registeredUsers: ["1", "2", "3"],
      image:
        "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg",
      createdAt: "2024-01-15T10:00:00Z",
      points: 50,
      registrationLink: "https://bits.edu.in/annual-tech-fest/",
    },
    {
      id: "2",
      src : "system",
      title: "Cultural Night",
      description:
        "Celebrate diversity with music, dance, and cultural performances from around the world.",
      date: "2024-02-20",
      time: "7:00 PM",
      location: "Open Air Theater",
      organizer: "Cultural Society",
      category: "Cultural",
      maxParticipants: 300,
      registeredUsers: ["2", "4"],
      image:
        "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg",
      createdAt: "2024-01-20T09:00:00Z",
      points: 30,
      registrationLink: "https://www.scmsnoida.ac.in/cultural_evening",
    },
    {
      id: "3",
      src : "system",
      title: "Career Fair 2025",
      description:
        "Meet top recruiters and explore career opportunities in various industries.",
      date: "2024-02-25",
      time: "9:00 AM",
      location: "Convention Center",
      organizer: "Placement Cell",
      category: "Career",
      maxParticipants: 800,
      registeredUsers: ["1", "3", "5"],
      image:
        "https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg",
      createdAt: "2024-01-25T11:00:00Z",
      points: 40,
      registrationLink:
        "https://rsvp.withgoogle.com/events/cloud-career-fair/home",
    },
  ],

  lostItems: [
    {
      id: "1",
      title: "Blue Samsung Galaxy S21",
      description:
        "Lost my blue Samsung Galaxy S21 near the library. Has a black case with card holder.",
      category: "Electronics",
      location: "Library",
      dateFound: "2024-01-20",
      reportedBy: "John Doe",
      contact: "john@college.edu",
      image: "https://images.pexels.com/photos/699122/pexels-photo-699122.jpeg",
      status: "lost",
      createdAt: "2024-01-20T14:30:00Z",
    },
    {
      id: "2",
      title: "Red Backpack",
      description:
        "Found a red backpack with laptop and textbooks near the cafeteria.",
      category: "Bags",
      location: "Cafeteria",
      dateFound: "2024-01-22",
      reportedBy: "Jane Smith",
      contact: "jane@college.edu",
      image:
        "https://images.pexels.com/photos/2905238/pexels-photo-2905238.jpeg",
      status: "found",
      createdAt: "2024-01-22T16:45:00Z",
    },
    {
      id: "3",
      title: "Silver MacBook Pro",
      description:
        "Lost my MacBook Pro in the computer lab. Has stickers on the back.",
      category: "Electronics",
      location: "Computer Lab",
      dateFound: "2024-01-25",
      reportedBy: "Mike Johnson",
      contact: "mike@college.edu",
      image: "https://images.pexels.com/photos/18105/pexels-photo.jpg",
      status: "lost",
      createdAt: "2024-01-25T13:20:00Z",
    },
  ],

  studyMaterials: [
    {
      id: "1",
      title: "Introduction to Programming Notes",
      description: "Basics of C programming with examples and exercises.",
      subject: "Computer Science",
      semester: "1st",
      fileType: "PDF",
      uploadedBy: "Prof. A. Sharma",
      fileSize: "1.2 MB",
      downloads: 321,
      tags: ["c-language", "basics", "programming"],
      createdAt: "2024-01-05T10:00:00Z",
      fileUrl:
        "https://drive.google.com/file/d/1E01pK6ib7eOzBiku_NSFPlbBN2olnijC/view",
    },
    {
      id: "2",
      title: "Engineering Physics Lecture Slides",
      description: "Complete slides for Unit 1–4 of Engineering Physics.",
      subject: "Physics",
      semester: "1st",
      fileType: "PPT",
      uploadedBy: "Prof. Neha Roy",
      fileSize: "4.1 MB",
      downloads: 198,
      tags: ["optics", "motion", "thermodynamics"],
      createdAt: "2024-01-06T11:00:00Z",
      fileUrl:
        "https://drive.google.com/file/d/1vvVlywtRaf6tJGwKQ8sGqXo9fpRAXP-w/view",
    },
    {
      id: "3",
      title: "Basic Electrical Engineering Notes",
      description: "Comprehensive theory notes with solved examples.",
      subject: "Electrical",
      semester: "1st",
      fileType: "PDF",
      uploadedBy: "Prof. Vikram Sinha",
      fileSize: "2.6 MB",
      downloads: 267,
      tags: ["current", "circuit", "ohm-law"],
      createdAt: "2024-01-07T13:00:00Z",
    },
    {
      id: "4",
      title: "Maths-I Practice Set",
      description: "Important problems with solutions for Maths-I.",
      subject: "Mathematics",
      semester: "1st",
      fileType: "PDF",
      uploadedBy: "Prof. J. Mehta",
      fileSize: "1.8 MB",
      downloads: 356,
      tags: ["limits", "differentiation", "integration"],
      createdAt: "2024-01-08T09:30:00Z",
      fileUrl: "#",
    },
    {
      id: "5",
      title: "Workshop Practice Lab Manual",
      description: "Step-by-step guide for practicals in workshop.",
      subject: "Mechanical",
      semester: "1st",
      fileType: "DOCX",
      uploadedBy: "Prof. Rajeev Kumar",
      fileSize: "2.1 MB",
      downloads: 144,
      tags: ["lathe", "fitting", "carpentry"],
      createdAt: "2024-01-09T12:00:00Z",
      fileUrl: "#",
    },
    {
      id: "6",
      title: "English Communication Workbook",
      description: "Practice worksheets for improving grammar and writing.",
      subject: "English",
      semester: "1st",
      fileType: "PDF",
      uploadedBy: "Prof. Anjali Desai",
      fileSize: "1.5 MB",
      downloads: 221,
      tags: ["writing", "grammar", "communication"],
      createdAt: "2024-01-10T15:00:00Z",
      fileUrl: "#",
    },
    {
      id: "7",
      title: "Calculus I Notes",
      description: "Detailed notes for first semester calculus.",
      subject: "Mathematics",
      semester: "1st",
      fileType: "PDF",
      uploadedBy: "Prof. D. Iyer",
      fileSize: "2.3 MB",
      downloads: 280,
      tags: ["calculus", "limits", "derivatives"],
      createdAt: "2024-01-11T08:45:00Z",
      fileUrl:
        "https://drive.google.com/file/d/1aR1jWqbZHM-IUQwzBOTACtMVMp2j5wFB/view",
    },
    {
      id: "8",
      title: "Engineering Chemistry Notes",
      description: "Unit-wise compiled notes for theory preparation.",
      subject: "Chemistry",
      semester: "2nd",
      fileType: "PDF",
      uploadedBy: "Prof. Sujata Nair",
      fileSize: "2.7 MB",
      downloads: 203,
      tags: ["organic", "chemical-bonding", "acids"],
      createdAt: "2024-01-12T10:15:00Z",
      fileUrl:
        "https://drive.google.com/file/d/1KFH1HejZwdEXq50bxm05A2t7mHHbXPW_/view",
    },
    {
      id: "9",
      title: "Physics Lab Readings",
      description: "All experiment readings and observations.",
      subject: "Physics",
      semester: "2nd",
      fileType: "XLSX",
      uploadedBy: "Lab Assistant",
      fileSize: "0.9 MB",
      downloads: 178,
      tags: ["lab", "experiments", "readings"],
      createdAt: "2024-01-13T14:10:00Z",
      fileUrl: "#",
    },
    {
      id: "10",
      title: "Environmental Science Guide",
      description: "Condensed guide for EVS with important topics.",
      subject: "EVS",
      semester: "2nd",
      fileType: "PDF",
      uploadedBy: "Prof. A. Chatterjee",
      fileSize: "1.4 MB",
      downloads: 239,
      tags: ["environment", "sustainability", "ecosystem"],
      createdAt: "2024-01-14T16:00:00Z",
      fileUrl:
        "https://drive.google.com/file/d/1VTeUPm3R1g_ka1r9jBz4pDg7bPXMg_Vu/view",
    },
    {
      id: "11",
      title: "C Programming Lab Sheet",
      description: "All programs with output screenshots.",
      subject: "Computer Science",
      semester: "2nd",
      fileType: "DOCX",
      uploadedBy: "Prof. Ankit Verma",
      fileSize: "1.9 MB",
      downloads: 311,
      tags: ["c-language", "lab", "programming"],
      createdAt: "2024-01-15T10:30:00Z",
      fileUrl: "#",
    },
    {
      id: "12",
      title: "Mathematics-II Question Bank",
      description: "Collection of previous year papers and questions.",
      subject: "Mathematics",
      semester: "2nd",
      fileType: "PDF",
      uploadedBy: "Prof. Neeraj Rana",
      fileSize: "2.0 MB",
      downloads: 197,
      tags: ["matrices", "differential", "vector"],
      createdAt: "2024-01-16T13:20:00Z",
      fileUrl: "#",
    },
    {
      id: "13",
      title: "Engineering Graphics Sheets",
      description: "All drawing sheets scanned and explained.",
      subject: "Graphics",
      semester: "2nd",
      fileType: "PDF",
      uploadedBy: "Prof. Rakesh Kapoor",
      fileSize: "3.5 MB",
      downloads: 154,
      tags: ["orthographic", "isometric", "drawing"],
      createdAt: "2024-01-17T09:45:00Z",
      fileUrl: "#",
    },
    {
      id: "14",
      title: "Chemistry Practicals",
      description: "Observation tables and analysis for each experiment.",
      subject: "Chemistry",
      semester: "2nd",
      fileType: "PDF",
      uploadedBy: "Lab Assistant",
      fileSize: "1.6 MB",
      downloads: 176,
      tags: ["practical", "chemistry", "observations"],
      createdAt: "2024-01-18T12:50:00Z",
      fileUrl: "#",
    },
    {
      id: "15",
      title: "Professional Ethics Notes",
      description: "Key topics and case studies for ethics subject.",
      subject: "Humanities",
      semester: "2nd",
      fileType: "PDF",
      uploadedBy: "Prof. Sneha Arora",
      fileSize: "1.3 MB",
      downloads: 122,
      tags: ["ethics", "values", "professionalism"],
      createdAt: "2024-01-19T11:10:00Z",
      fileUrl: "#",
    },
  ],

  studyGroups: [
    {
      id: "1",
      title: "Machine Learning Study Group",
      description:
        "Weekly study sessions for machine learning concepts and projects.",
      subject: "Computer Science",
      maxMembers: 8,
      members: ["1", "2", "3"],
      createdBy: "Alex Kumar",
      meetingTime: "Saturdays 2:00 PM",
      location: "Library Room 201",
      difficulty: "Intermediate",
      goals: ["Complete ML course", "Work on projects", "Prepare for exams"],
      createdAt: "2024-01-10T10:00:00Z",
    },
    {
      id: "2",
      title: "GATE Preparation Group",
      description:
        "Intensive preparation group for GATE computer science examination.",
      subject: "Computer Science",
      maxMembers: 12,
      members: ["2", "4", "5"],
      createdBy: "Priya Sharma",
      meetingTime: "Daily 6:00 PM",
      location: "Study Hall A",
      difficulty: "Advanced",
      goals: ["GATE preparation", "Mock tests", "Doubt clearing"],
      createdAt: "2024-01-12T08:30:00Z",
    },
    {
      id: "3",
      title: "Interview Preparation Circle",
      description:
        "Practice coding interviews and soft skills for placement preparation.",
      subject: "Career Development",
      maxMembers: 10,
      members: ["1", "3", "4"],
      createdBy: "Rahul Gupta",
      meetingTime: "Tuesdays & Thursdays 7:00 PM",
      location: "Conference Room B",
      difficulty: "All Levels",
      goals: ["Coding practice", "Mock interviews", "Resume building"],
      createdAt: "2024-01-14T16:20:00Z",
    },
  ],

  mediaItems: [
    {
      id: "1",
      title: "When you finally understand recursion",
      type: "meme",
      imageUrl:
        "https://images.pexels.com/photos/1181244/pexels-photo-1181244.jpeg",
      caption: "The moment of enlightenment every CS student experiences",
      uploadedBy: "CodeMaster123",
      likes: 156,
      comments: [
        {
          id: "1",
          user: "TechGuru",
          text: "So relatable! 😄",
          createdAt: "2024-01-20T10:30:00Z",
        },
        {
          id: "2",
          user: "StudentLife",
          text: "Took me 3 semesters to get this",
          createdAt: "2024-01-20T11:45:00Z",
        },
      ],
      tags: ["programming", "recursion", "computer-science"],
      createdAt: "2024-01-20T09:15:00Z",
    },
    {
      id: "2",
      title: "Campus Sunset Gallery",
      type: "gallery",
      imageUrl:
        "https://images.pexels.com/photos/1763075/pexels-photo-1763075.jpeg",
      caption: "Beautiful sunset views from our campus",
      uploadedBy: "NaturePhotographer",
      likes: 89,
      comments: [
        {
          id: "3",
          user: "ArtLover",
          text: "Stunning capture!",
          createdAt: "2024-01-21T14:20:00Z",
        },
      ],
      tags: ["photography", "sunset", "campus"],
      createdAt: "2024-01-21T18:45:00Z",
    },
    {
      id: "3",
      title: "Exam week be like",
      type: "meme",
      imageUrl:
        "https://images.pexels.com/photos/1181354/pexels-photo-1181354.jpeg",
      caption: "Coffee is the only reason I am still alive",
      uploadedBy: "CoffeeLover",
      likes: 234,
      comments: [
        {
          id: "4",
          user: "StudyBuddy",
          text: "I felt this in my soul",
          createdAt: "2024-01-22T09:30:00Z",
        },
        {
          id: "5",
          user: "ExamSurvivor",
          text: "Same energy every semester",
          createdAt: "2024-01-22T10:15:00Z",
        },
      ],
      tags: ["exam", "coffee", "student-life"],
      createdAt: "2024-01-22T08:00:00Z",
    },
  ],

  reports: [
    {
      id: "1",
      title: "Inappropriate behavior in hostel",
      description: "Reporting incident of ragging in hostel block A",
      category: "Ragging",
      location: "Hostel Block A",
      incidentDate: "2024-01-18",
      reportedBy: "Anonymous",
      severity: "High",
      status: "pending",
      witnesses: false,
      additionalInfo: "Incident occurred during evening hours",
      createdAt: "2024-01-19T20:30:00Z",
    },
    {
      id: "2",
      title: "Harassment in classroom",
      description: "Student facing harassment from seniors",
      category: "Harassment",
      location: "Classroom 301",
      incidentDate: "2024-01-20",
      reportedBy: "Anonymous",
      severity: "Medium",
      status: "under-review",
      witnesses: true,
      additionalInfo: "Multiple witnesses available",
      createdAt: "2024-01-21T15:45:00Z",
    },
  ],

  notifications: [
    {
      id: "1",
      title: "New Event: Tech Fest 2024",
      message: "Annual Tech Fest registration is now open!",
      type: "event",
      read: false,
      createdAt: "2024-01-15T10:00:00Z",
    },
    {
      id: "2",
      title: "Study Material Uploaded",
      message: "New Data Structures notes have been uploaded",
      type: "study-material",
      read: false,
      createdAt: "2024-01-16T14:30:00Z",
    },
    {
      id: "3",
      title: "Study Group Invitation",
      message: "You have been invited to join Machine Learning Study Group",
      type: "study-group",
      read: true,
      createdAt: "2024-01-17T11:20:00Z",
    },
  ],

  users: [
    {
      id: "1",
      name: "John Doe",
      email: "john@college.edu",
      role: "student",
      department: "Computer Science",
      year: "3rd",
      points: 150,
      joinedAt: "2024-01-01T00:00:00Z",
    },
    {
      id: "2",
      name: "Jane Smith",
      email: "jane@college.edu",
      role: "student",
      department: "Electronics",
      year: "2nd",
      points: 120,
      joinedAt: "2024-01-02T00:00:00Z",
    },
    {
      id: "3",
      name: "Mike Johnson",
      email: "mike@college.edu",
      role: "student",
      department: "Computer Science",
      year: "4th",
      points: 200,
      joinedAt: "2024-01-03T00:00:00Z",
    },
    {
      id: "4",
      name: "Prof. Sarah Wilson",
      email: "sarah@college.edu",
      role: "faculty",
      department: "Computer Science",
      points: 0,
      joinedAt: "2024-01-01T00:00:00Z",
    },
  ],
};

export const sellItems = [
  {
    id: 1,
    title: "Wireless Mouse",
    description: "Almost new Logitech mouse.",
    category: "electronics",
    location: "Block A",
    datePosted: new Date().toISOString(),
    sellerName: "Ravi Kumar",
    contact: "9876543210",
    price: 800,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR1EOgfsvcz9CrhHHTGIZ_JAsU4KxUvmUv1wA&s",
  },
  {
    id: 2,
    title: "Casio Scientific Calculator FX-991EX",
    description: "Perfect working condition, used for 1 semester.",
    category: "electronics",
    location: "Hostel C - Room 202",
    datePosted: new Date().toISOString(),
    sellerName: "Rahul Sharma",
    contact: "9876543210",
    price: 950,
    image:
      "https://images-cdn.ubuy.co.in/63575d3f82109e26b31cf994-scientific-calculator-401funtions-with.jpg",
  },
  {
    id: 3,
    title: "Engineering Drawing Kit",
    description: "Includes drafter, set squares, compass, etc.",
    category: "stationary",
    location: "Block B",
    datePosted: new Date().toISOString(),
    sellerName: "Anjali Mehra",
    contact: "9876543211",
    price: 300,
    image:
      "https://apollo.olx.in/v1/files/qhxw5hfz1l4r3-IN/image;s=300x600;q=60",
  },
  {
    id: 4,
    title: "Used Books - 1st Year CSE",
    description: "Bundle of 5 books including Physics, Maths, EM, etc.",
    category: "books",
    location: "Library Entrance",
    datePosted: new Date().toISOString(),
    sellerName: "Suresh Singh",
    contact: "9876543212",
    price: 1200,
    image:
      "https://images.careerindia.com/img/2018/03/manufacturingprocess-1520416569.jpg",
  },
  {
    id: 5,
    title: "Table Fan",
    description: "Compact and working well. Used in hostel.",
    category: "electronics",
    location: "Hostel A - Room 105",
    datePosted: new Date().toISOString(),
    sellerName: "Meena Rathi",
    contact: "9876543213",
    price: 600,
    image: "https://images.meesho.com/images/products/92361669/49gnp_512.webp",
  },
  {
    id: 6,
    title: "Bluetooth Earphones",
    description: "Boat Rockerz 255, decent battery backup.",
    category: "electronics",
    location: "Cafeteria",
    datePosted: new Date().toISOString(),
    sellerName: "Aman Verma",
    contact: "9876543214",
    price: 700,
    image:
      "https://m.media-amazon.com/images/I/516WC9VNHVL._AC_UF1000,1000_QL80_.jpg",
  },
  {
    id: 7,
    title: "Desk Lamp",
    description: "LED lamp with adjustable neck, white color.",
    category: "others",
    location: "Block D",
    datePosted: new Date().toISOString(),
    sellerName: "Priya Singh",
    contact: "9876543215",
    price: 250,
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSjs8JJLwf15qvNGRD8KPj1UkzacPJnlQYeOg&s",
  },
  {
    id: 8,
    title: "Laptop Stand",
    description: "Metal build, ergonomic design.",
    category: "others",
    location: "Library Exit",
    datePosted: new Date().toISOString(),
    sellerName: "Mohit Jain",
    contact: "9876543216",
    price: 350,
    image:
      "https://s3-eu-west-1.amazonaws.com/backcslimages/newsite/product-images/1500-1500/FoldineX-Laptop-Stand-Desk.jpg",
  },
  {
    id: 9,
    title: "Water Bottle - Milton",
    description: "1L bottle, stainless steel, new.",
    category: "others",
    location: "Hostel B - Room 301",
    datePosted: new Date().toISOString(),
    sellerName: "Divya Kapoor",
    contact: "9876543217",
    price: 200,
    image: "https://m.media-amazon.com/images/I/51Da+TBexCL.jpg",
  },
  {
    id: 10,
    title: "Pen Drive - 64GB",
    description: "SanDisk USB 3.0, barely used.",
    category: "electronics",
    location: "Block C",
    datePosted: new Date().toISOString(),
    sellerName: "Karan Malhotra",
    contact: "9876543218",
    price: 500,
    image:
      "https://rukminim2.flixcart.com/image/850/1000/jusp3m80/pendrive/pendrive/2/z/c/sandisk-pendrive-32-gb-original-imafftghgacghnz4.jpeg?q=90&crop=false",
  },
];

export const hackathons = [
  {
    id: 7397,
    city: null,
    name: "ETHIndia Fellowship 3.0",
    slug: "eif3",
    type: "FELLOWSHIP",
    registrationLink : 'https://eif3.devfolio.co/',
    uuid: "97a12d19ff434e56abf9b7a33e631b02",
    state: null,
    rating: 0,
    country: null,
    ends_at: "2023-04-04T18:29:00+00:00",
    favicon:
      "https://assets.devfolio.co/hackathons/97a12d19ff434e56abf9b7a33e631b02/assets/favicon/269.png",
    tagline: "Join the next wave of Web3 devs who build to learn.",
    timezone: "Asia/Calcutta",
    is_online: false,
    starts_at: "2023-02-02T18:30:00+00:00",
    apply_mode: "both",
    devfolio_official: true,
    hackathon_setting: {
      logo: "https://assets.devfolio.co/hackathons/97a12d19ff434e56abf9b7a33e631b02/assets/logo/689.png",
      site: null,
      uuid: "90b221356f1541fcae361356bc655114",
      slack: null,
      medium: null,
      review: true,
      discord: "https://nsb.dev/discord",
      twitter: "https://twitter.com/ethindiaco",
      facebook: null,
      linkedin: null,
      telegram: "https://t.me/ethindiaco",
      instagram: "https://instagram.com/ethindiaco",
      reg_ends_at: "2023-01-17T18:29:00+00:00",
      primary_color: "#faf7f0",
      reg_starts_at: "2022-11-14T12:30:00+00:00",
    },
  },
  {
    id: 8250,
    city: null,
    name: "ETHIndia Grants 2.0",
    slug: "ethindiagrants",
    registrationLink : 'https://ethindia.devfolio.co/',
    type: "GRANT",
    uuid: "31c946a6253a4c72bb2d15568f28bd9b",
    state: null,
    rating: 0,
    country: null,
    ends_at: "2024-12-01T18:29:00+00:00",
    favicon:
      "https://assets.devfolio.co/hackathons/31c946a6253a4c72bb2d15568f28bd9b/assets/favicon/358.png",
    tagline: "Build a thriving Ethereum ecosystem, one project at a time 🌱",
    timezone: "Asia/Calcutta",
    is_online: false,
    starts_at: "2023-05-01T12:30:00+00:00",
    apply_mode: "both",
    devfolio_official: true,
    hackathon_setting: {
      logo: "https://assets.devfolio.co/hackathons/31c946a6253a4c72bb2d15568f28bd9b/assets/logo/471.png",
      site: null,
      uuid: "8dc3a5b4392c418db4b9bf1e120fdd02",
      slack: null,
      medium: null,
      review: true,
      discord: "https://nsb.dev/discord",
      twitter: "https://twitter.com/ETHIndiaco",
      facebook: null,
      linkedin: "https://www.linkedin.com/company/devfolio/",
      telegram: "https://t.me/ethindiaco",
      instagram: null,
      reg_ends_at: "2024-12-01T18:29:00+00:00",
      primary_color: "#c39341",
      reg_starts_at: "2023-04-24T11:30:00+00:00",
    },
  },
  {
    id: 13282,
    city: null,
    name: "MumbaiHacks 2025 - Round 1 (Online)",
    slug: "mumbaihacks25-round1",
    type: "HACKATHON",
    uuid: "8d5c2af9a0094cb592f57726ecc31003",
    registrationLink : 'https://mumbaihacks.com/',
    state: null,
    rating: 0,
    country: null,
    ends_at: "2025-08-31T18:29:00+00:00",
    favicon:
      "https://assets.devfolio.co/hackathons/8d5c2af9a0094cb592f57726ecc31003/assets/favicon/980.png",
    tagline: "The World's Largest GenAI Hackathon is back!",
    timezone: "Asia/Calcutta",
    is_online: true,
    starts_at: "2025-08-11T18:30:00+00:00",
    apply_mode: "both",
    devfolio_official: null,
    hackathon_setting: {
      logo: "https://assets.devfolio.co/hackathons/8d5c2af9a0094cb592f57726ecc31003/assets/logo/211.png",
      site: "https://mumbaihacks.com/",
      uuid: "dc3f732f413c47cc8bd82210673f73c0",
      slack: null,
      medium: null,
      review: false,
      discord: null,
      twitter: "https://linktr.ee/mumbaihacks",
      facebook: null,
      linkedin: "https://linktr.ee/mumbaihacks",
      telegram: null,
      farcaster: null,
      instagram: "https://linktr.ee/mumbaihacks",
      reg_ends_at: "2025-08-30T18:29:00+00:00",
      primary_color: "#761713",
      reg_starts_at: "2025-07-02T18:30:00+00:00",
      external_apply_url: null,
    },
  },
  {
    id: 13310,
    city: null,
    name: "Onchain Summer Awards",
    slug: "onchain-summer-awards",
    registrationLink : 'https://onchainsummer.xyz/',
    type: "HACKATHON",
    uuid: "7bf7cc43788e4efabe261b0b2de34d8f",
    state: null,
    rating: 0,
    country: null,
    ends_at: "2025-08-26T19:30:00+00:00",
    favicon:
      "https://assets.devfolio.co/hackathons/7bf7cc43788e4efabe261b0b2de34d8f/assets/favicon/803.png",
    tagline: "Build. Launch. Scale. Earn.",
    timezone: "US/Pacific",
    is_online: true,
    starts_at: "2025-07-10T03:30:00+00:00",
    apply_mode: "both",
    devfolio_official: false,
    hackathon_setting: {
      logo: "https://assets.devfolio.co/hackathons/7bf7cc43788e4efabe261b0b2de34d8f/assets/logo/993.png",
      site: "https://onchainsummer.xyz",
      uuid: "96be91d346e34137a8803f1745111ea4",
      slack: null,
      medium: null,
      review: false,
      discord: "https://base.org/discord",
      twitter: "https://x.com/base",
      facebook: null,
      linkedin: null,
      telegram: null,
      farcaster: "https://farcaster.xyz/base",
      instagram: null,
      reg_ends_at: "2025-08-26T19:30:00+00:00",
      primary_color: "#0693e3",
      reg_starts_at: "2025-07-10T03:30:00+00:00",
      external_apply_url: null,
    },
  },
  {
    id: 51,
    uuid: "3e3f093d2a9548d194c9612ebc477259",
    type: "Technology",
    image:
      "https://assets.devfolio.co/content/306baf2474b84076b2312e0969a17a70/59c354d5-9ffc-4f48-882c-10437d4a72af.jpeg",
    title: "10 Years of Ethereum Meetups",
    end_time: "2025-06-30T15:30:00+00:00",
    location: "Bangalore, India",
    registrationLink : 'https://lu.ma/id8ftmym',
    is_online: false,
    start_time: "2025-06-30T10:30:00+00:00",
    description:
      "Ethereum turns 10.\nJoin builders and contributors to reflect and plan what’s next.\nCelebrate the past, shape the future.",
  },
  {
    id: 53,
    type: "Technology",
    url: "https://events.linuxfoundation.org/kubecon-cloudnativecon-india/",
    uuid: "6b648c70d20e4774a4ecab6c2a0d60dd",
    registrationLink : 'https://events.linuxfoundation.org/kubecon-cloudnativecon-india/',
    image:
      "https://assets.devfolio.co/content/306baf2474b84076b2312e0969a17a70/f29b40f3-ee42-4aa2-9c4f-780deff6026a.png",
    title: "KubeCon + CloudNativeCon India 2025",
    end_time: "2025-08-07T11:55:00+00:00",
    location: "Hyderabad, Telangana",
    is_online: false,
    start_time: "2025-08-06T11:55:00+00:00",
    description:
      "The Cloud Native Computing Foundation’s flagship conference brings together adopters and technologists from leading open source and cloud native communities.",
  },
];

